import React from 'react'
import { connect } from 'react-redux'
import "../../../styles/integration-styles.scss"
import { setGlobalLoading } from 'redux/actions/actionCommon'
import IntegrationCard from './Includes/IntegrationCard'
import IntegrationTopBar from './Includes/IntegrationTopBar'
import IntegratioTableCard from './Includes/IntegratioTableCard'


function IntegrationTable(props) {

    return (
        <section id="app-integrations-view" >
            <div className="integration-content border-bottom pad-20-T pad-20-B pad-12-L pad-12-R">
                <div className="app-header-wrapper heading-sm mb-1 pad-12-L">
                    <p className="app-heading text-capitalize">Recommended for you</p>
                </div>
                <IntegrationCard />
            </div>
            <IntegrationTopBar />
            <div className="pad-12-L pad-12-R pad-12-B">
                <IntegratioTableCard />
            </div>
        </section >
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}


export default connect(getDataFromStore, dispatchActionsToProps)(IntegrationTable)